export enum BinaryState {
  YES = 'YES',
  NO = 'NO'
}
